import {
  TransactionExecutionError,
  ContractFunctionExecutionError,
} from 'viem';

export function getTxErrorMessage(error: Error, defaultMessage: string) {
  let message = (error as Error).message || defaultMessage;

  if (error instanceof TransactionExecutionError) {
    message = error.shortMessage;
  }

  if (error instanceof ContractFunctionExecutionError) {
    message =
      error.shortMessage +
      '\n\n' +
      (error.metaMessages && error.metaMessages[0]);
  }

  return message;
}
